import { atom } from "recoil";
import availableVolunteers from "../../experience/carecoordinator/dashboard/assets/json/trendsDummyData.json";
import careHoursJson from "../../experience/carecoordinator/dashboard/assets/json/careHours.json";
import savingsJson from "../../experience/carecoordinator/dashboard/assets/json/savings.json";
import inactiveJson from "../../experience/carecoordinator/dashboard/assets/json/inactive.json";

export const availableVolunteersJson = atom({
  key: "availableVolunteers",
  default: {
    title: "Total Volunteers",
    number: "164",
    subContent: "30 Active 134 Busy",
    data: availableVolunteers,
  },
});

export const busyVolunteersJson = atom({
  key: "busyVolunteers",
  default: {
    title: "Care Hours",
    number: "58",
    subContent: "25.8 Travel",
    data: careHoursJson,
  },
});

export const patientVolunterringHoursJson = atom({
  key: "patientVolunterringHours",
  default: {
    title: "Savings",
    number: "$1742",
    subContent: "$516 Mileage $1226 Wages",
    data: savingsJson,
  },
});

export const nonPatientVolunteeringHoursJson = atom({
  key: "nonPatientVolunteeringHours",
  default: {
    title: "Inactive",
    number: "25",
    subContent: "5 Drop-out 20 On-Break",
    data: inactiveJson,
  },
});
